import { map } from 'lodash'
import bus from '@/utils/eventBus'
import { error } from '@/utils/alert'

export default {
  doDelayedAll () {
    const ids = map(this.schedules, schedule => {
      return schedule.id
    })

    this.$resource.put(ids.toString() + '/delayed')
      .then(({data}) => {
        bus.$emit('is-delayed', {show: true})
        this.$emit('close', data)
      })
      .catch(() => {
        error('Ocorreu um erro ao confirmar este horário.')
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/components/delayed/resources/methods.js